import { render } from "./Tyre.vue?vue&type=template&id=be6559ee&scoped=true"
import script from "./Tyre.vue?vue&type=script&lang=js"
export * from "./Tyre.vue?vue&type=script&lang=js"

import "./Tyre.vue?vue&type=style&index=0&id=be6559ee&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6559ee"]])

export default __exports__